import React from 'react';
import { ListItem } from '@material-ui/core';
import ResultListItemText from '../components/ResultListItemText';
import ResultListItemAvatar from '../components/ResultListItemAvatar';
import { getSuggestionPrimaryText, getSuggestionSecondaryText } from '../../tasks/helper';

const RefereeEntityListItem = ({ entity, onClick }) => (
  <ListItem button onClick={onClick} style={{ height: 60 }}>
    <ResultListItemAvatar entityId={entity.id} entityType="referee" imgKey="" />
    <ResultListItemText
      primary={getSuggestionPrimaryText('referee', entity)}
      secondary={getSuggestionSecondaryText('referee', entity)}
    />
  </ListItem>
);

export default RefereeEntityListItem;
